import React, { Component } from 'react';
import { CheckBox, Box, Table, TableRow, TableCell, TableBody, TableHeader, Text, RadioButtonGroup, Button, TextInput, FormField } from 'grommet';
import * as moment from 'moment';

import { withFirebase } from '../Firebase';
import { getUserWallet, adjustWallet } from '../../lib/walletApi';
import { setTierOverride } from '../../lib/subscriptionApi';
 
class UserPage extends Component {
  constructor(props) {
    super(props);
 
    this.state = {
      loading: false,
      user: null,
      profile: null,
      promotedPosts: [],
      genres: [],
      wallet: null,
      walletError: null,
      adjustDelta: '',
      adjustNote: '',
      adjusting: false,
      tier: null,
      tierOverrideActive: false,
      tierError: null,
    };
  }
 
  async componentDidMount() {
    this.setState({ loading: true });

    const uid = this.props.match.params.uid || this.props.uid;

    this.props.firebase.genres().on('value', snapshot => {
      this.setState({
        genres: snapshot.val(),
      });
    });

    this.props.firebase.user(uid).on('value', snapshot => { 
      this.setState({
        user: snapshot.val(),
        profile: this.state.profile,
        loading: !this.state.profile,
      });
    });
 
    this.props.firebase.profile(uid).on('value', snapshot => {
      this.setState({
        profile: snapshot.val(),
        user: this.state.user,
        loading: !this.state.user,
      });
    });

    this.props.firebase.promotedPosts().on('value', snapshot => {
      const promotedPosts = snapshot.val();
      const userPromotedPosts = Object.keys(promotedPosts).filter(postId => promotedPosts[postId].user_id === uid);
      this.setState({
        promotedPosts: userPromotedPosts.map(postId => promotedPosts[postId]).sort((a, b) => b.promoted_at - a.promoted_at),
      });
    });

    const snapshot = await this.props.firebase.profiles().orderByChild('referral_user_id').equalTo(uid).once('value');
    this.setState({
      profile: this.state.profile,
      user: this.state.user,
      referredUsers: snapshot.val(),
      loading: !this.state.user,
    })

    this.loadWallet(uid);

    this.props.firebase.subscription(uid).on('value', snapshot => {
      const sub = snapshot.val() || {};
      this.setState({ tier: sub.tier || 'free', tierOverrideActive: !!sub.admin_override });
    });
  }

  onOverrideTier = async (tier) => {
    const uid = this.props.match.params.uid || this.props.uid;
    this.setState({ tierError: null });
    try {
      // The /subscriptions listener reflects the new tier once the server writes.
      await setTierOverride(this.props.firebase)({ userId: uid, tier });
    } catch (err) {
      this.setState({ tierError: err.message || 'Tier override failed' });
    }
  }

  loadWallet = async (uid) => {
    try {
      const wallet = await getUserWallet(this.props.firebase)(uid);
      this.setState({ wallet, walletError: null });
    } catch (err) {
      this.setState({ walletError: err.message || 'Failed to load wallet' });
    }
  }

  onAdjust = async () => {
    const uid = this.props.match.params.uid || this.props.uid;
    const { adjustDelta, adjustNote } = this.state;
    const delta = parseInt(adjustDelta, 10);
    if (!Number.isFinite(delta) || delta === 0) {
      this.setState({ walletError: 'Adjustment must be a non-zero integer.' });
      return;
    }
    this.setState({ adjusting: true, walletError: null });
    try {
      await adjustWallet(this.props.firebase)({
        userId: uid,
        delta,
        note: adjustNote,
      });
      const wallet = await getUserWallet(this.props.firebase)(uid);
      this.setState({ wallet, adjustDelta: '', adjustNote: '', adjusting: false });
    } catch (err) {
      this.setState({ walletError: err.message || 'Adjustment failed', adjusting: false });
    }
  }

  componentWillUnmount() {
    const uid = this.props.match.params.uid || this.props.uid;
    this.props.firebase.user(uid).off();
    this.props.firebase.profile(uid).off();
    this.props.firebase.promotedPosts().off();
    this.props.firebase.genres().off();
    this.props.firebase.subscription(uid).off();
  }

  onUpdatePhone() {
    console.log(this.props);
    const number = prompt('Please enter a new 10-digit phone number. Do not include the country code.');
    const uid = this.props.match.params.uid || this.props.uid;

    this.props.firebase.auth
      .currentUser
      .getIdToken()
      .then(token => {
        return fetch(
          process.env.REACT_APP_API_URL + "/support/updatePhoneNumber",
          {
            method: 'PUT',
            headers: {
              'Authorization': "Bearer " + token,
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              user_id: uid,
              phone: number
            })
          }
        )
      })
      .then(response => response.json())
      .then(value => {
        alert(`Phone number updated to ${number}.`);
      })
      .catch(error => {
        alert(error);
      });
  }
 
  render() {
    const { user, profile, referredUsers, promotedPosts, genres, loading, wallet, walletError, adjustDelta, adjustNote, adjusting, tier, tierOverrideActive, tierError } = this.state;

    return (
      <div>
        {loading && <div>Loading ...</div>}

        <Box direction="row-responsive" pad="medium" wrap={true} fill={true}>
          <Box pad="medium" width="large" fill="vertical">
            <UserDetail gridArea="left" user={user || {}} profile={profile || {}} referredUsers={referredUsers} promotedPosts={promotedPosts} genres={genres} />
          </Box>
          <Box pad="medium" width="medium" fill="vertical">
            <UserManage
              gridArea="right"
              user={user || {}}
              profile={profile || {}}
              background="light-2"
              onChangePhone={() => this.onUpdatePhone()}
              onChangeAdmin={(x) => this.props.firebase.setAdmin(user.id, x)}
              onChangeWatcher={(x) => this.props.firebase.setWatcher(user.id, x)}
              onChangeManager={(x) => this.props.firebase.setManager(user.id, x)}
              onOverrideLevel={(x) => this.props.firebase.setLevelOverride(user.id, x)}
              tier={tier}
              tierOverrideActive={tierOverrideActive}
              tierError={tierError}
              onOverrideTier={this.onOverrideTier}
              onDeleteAccount={() => this.props.firebase.deleteAccount(user, profile)}
              onReturnToOnboarding={() => this.props.firebase.returnToOnboarding(user.id)}
            />
          </Box>
        </Box>

        <WalletPanel
          wallet={wallet}
          error={walletError}
          adjustDelta={adjustDelta}
          adjustNote={adjustNote}
          adjusting={adjusting}
          onChangeDelta={(e) => this.setState({ adjustDelta: e.target.value })}
          onChangeNote={(e) => this.setState({ adjustNote: e.target.value })}
          onApply={this.onAdjust}
        />
      </div>
    );
  }
}

const WalletPanel = ({ wallet, error, adjustDelta, adjustNote, adjusting, onChangeDelta, onChangeNote, onApply }) => {
  if (!wallet && !error) {
    return (
      <Box pad="medium" border={{ side: 'top' }}>
        <Text size="medium" weight="bold">Wallet</Text>
        <Text>Loading…</Text>
      </Box>
    );
  }

  const transactions = (wallet && wallet.transactions) || [];
  const deltaParsed = parseInt(adjustDelta, 10);
  const disabled = adjusting || !Number.isFinite(deltaParsed) || deltaParsed === 0;

  return (
    <Box pad="medium" border={{ side: 'top' }} gap="small">
      <Text size="medium" weight="bold">Wallet</Text>
      {error && <Text color="status-critical">{error}</Text>}
      {wallet && (
        <>
          <Text>Balance: <strong>{wallet.balance}</strong></Text>
          {wallet.updated_at && (
            <Text size="small" color="text-weak">
              Updated {moment(wallet.updated_at).fromNow()}
            </Text>
          )}

          <Text margin={{ top: 'small' }} weight="bold">Recent activity</Text>
          {transactions.length === 0 && <Text size="small">No transactions yet.</Text>}
          {transactions.slice(0, 10).map((t) => (
            <Box key={t.id} direction="row" gap="small">
              <Text size="small" style={{ minWidth: '90px' }}>
                {moment(t.created_at).format('YYYY-MM-DD')}
              </Text>
              <Text
                size="small"
                color={t.delta > 0 ? 'status-ok' : 'status-critical'}
                style={{ minWidth: '50px' }}
              >
                {t.delta > 0 ? `+${t.delta}` : t.delta}
              </Text>
              <Text size="small">{t.reason}</Text>
            </Box>
          ))}

          <Box direction="row" gap="small" margin={{ top: 'small' }} align="end">
            <FormField label="Adjust by (signed)">
              <TextInput
                type="number"
                value={adjustDelta}
                onChange={onChangeDelta}
              />
            </FormField>
            <FormField label="Note">
              <TextInput value={adjustNote} onChange={onChangeNote} />
            </FormField>
            <Button
              primary
              label={adjusting ? 'Applying…' : 'Apply'}
              onClick={onApply}
              disabled={disabled}
            />
          </Box>
        </>
      )}
    </Box>
  );
};

const UserManage = ({ user, profile, onChangeAdmin, onChangeWatcher, onChangeManager, onChangePhone, onOverrideLevel, tier, tierOverrideActive, tierError, onOverrideTier, onDeleteAccount, onReturnToOnboarding }) => (
  <Box gap="medium">
    <CheckBox
      checked={user.is_admin}
      label="Admin"
      onChange={(event) => onChangeAdmin(event.target.checked)}
    />
    <CheckBox
      checked={profile.is_watcher}
      label="Industry Exec"
      onChange={(event) => onChangeWatcher(event.target.checked)}
    />
    <CheckBox
      checked={profile.is_manager}
      label="Manager"
      onChange={(event) => onChangeManager(event.target.checked)}
    />
    <strong>Connect Level Override:</strong>
    <RadioButtonGroup
      name="level_override"
      options={[
        {
          value: "disabled",
          label: "Disable"
        },
        {
          value: "none",
          label: "None"
        },
        {
          value: "bronze",
          label: "Bronze"
        },
        {
          value: "silver",
          label: "Silver"
        },
        {
          value: "gold",
          label: "Gold"
        },
      ]}
      value={profile.level_override || "disabled"}
      onChange={(event) => onOverrideLevel(event.target.value)}
    />
    <strong>Subscription Tier Override:</strong>
    <RadioButtonGroup
      name="tier_override"
      options={[
        { value: "disabled", label: "Disable (use real subscription)" },
        { value: "free", label: "Free" },
        { value: "creator", label: "Creator (silver)" },
        { value: "pro", label: "Pro (gold)" },
        { value: "business", label: "Business (platinum)" },
      ]}
      value={tierOverrideActive ? (tier || "free") : "disabled"}
      onChange={(event) => onOverrideTier(event.target.value)}
    />
    {tierError && <Text color="status-critical">{tierError}</Text>}
    <Button primary color="#FFFB00" label="Return to Onboarding" onClick={onReturnToOnboarding} />
    <Button secondary label="Change Phone Number" onClick={onChangePhone} />
    <Button primary color="#FF2600" label="Delete Account" onClick={onDeleteAccount} />
  </Box>
);

const UserDetail = ({ user, profile, referredUsers, promotedPosts, genres }) => (
  <Table>
    <TableBody>
      <TableRow>
        <TableCell scope="row">
          <strong>Full Name</strong>
        </TableCell>
        <TableCell scope="row">
          {user.first_name} {user.last_name}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell scope="row">
          <strong>Alias</strong>
        </TableCell>
        <TableCell scope="row">
          {profile.alias}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell scope="row">
          <strong>ID</strong>
        </TableCell>
        <TableCell scope="row">
        <a target="_blank" href={`https://console.firebase.google.com/u/0/project/${process.env.REACT_APP_PROJECT_ID}/database/${process.env.REACT_APP_PROJECT_ID}/data/${encodeURIComponent(`users/${user.id}`)}`}>{user.id}</a>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell scope="row">
          <strong>Email</strong>
        </TableCell>
        <TableCell scope="row">
          {user.email}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell scope="row">
          <strong>Phone</strong>
        </TableCell>
        <TableCell scope="row">
          {user.phone}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell scope="row">
          <strong>Location</strong>
        </TableCell>
        <TableCell scope="row">
          {profile.location ? `${profile.location.city}, ${profile.location.state} ${profile.location.postal_code}` : 'missing'}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell scope="row">
          <strong>Bio</strong>
        </TableCell>
        <TableCell scope="row">
          {profile.bio}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell scope="row">
          <strong>Submerchant ID</strong>
        </TableCell>
        <TableCell scope="row">
          {user.stripe_account_id}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell scope="row">
          <strong>Submerchant Status</strong>
        </TableCell>
        <TableCell scope="row">
          {user.stripe_account_status}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell scope="row">
          <strong>Signed Up</strong>
        </TableCell>
        <TableCell scope="row">
          {moment(profile.created_at).fromNow() + ', ' + moment(profile.created_at).format("lll")}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell scope="row">
          <strong>Last Active</strong>
        </TableCell>
        <TableCell scope="row">
          {moment(profile.last_active).fromNow() + ', ' + moment(profile.last_active).format("lll")}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell scope="row">
          <strong>Last Opened</strong>
        </TableCell>
        <TableCell scope="row">
          {moment(user.last_opened_at).fromNow() + ', ' + moment(user.last_opened_at).format("lll")}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell scope="row" style={{ top: 0 }}>
          <strong>Promoted Posts ({Object.keys(promotedPosts || {}).length})</strong>
        </TableCell>
        <TableCell scope="row" style={{ border: '1px solid black', height: 210, overflow: 'scroll' }}>
          <Table>
            <TableHeader>
              <TableRow>
                <TableCell scope="row">
                  <strong>Post ID</strong>
                </TableCell>
                <TableCell scope="row">
                  <strong>Promoted At</strong>
                </TableCell>
                <TableCell scope="row">
                  <strong>Genre</strong>
                </TableCell>
                <TableCell scope="row">
                  <strong>Product ID</strong>
                </TableCell>
              </TableRow>
            </TableHeader>
            <TableBody>
              {promotedPosts.map((post) => (
                <TableRow key={post.post_id}>
                  <TableCell scope="row">
                    <a target="_blank" href={`https://console.firebase.google.com/u/0/project/${process.env.REACT_APP_PROJECT_ID}/database/${process.env.REACT_APP_PROJECT_ID}/data/${encodeURIComponent(`status_updates/${post.post_id}`)}`}>View post</a>
                  </TableCell>
                  <TableCell scope="row">
                    {moment(post.promoted_at).format("lll")}
                  </TableCell>
                  <TableCell scope="row">
                    {post.genre_ids && Object.keys(post.genre_ids).map(genreId => genres[genreId].name).join(', ')}
                    {post.genre_id && genres[post.genre_id].name}
                  </TableCell>
                  <TableCell scope="row">
                    {post.product_id}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell scope="row" style={{ top: 0 }}>
          <strong>Referred Users ({Object.keys(referredUsers || {}).length})</strong>
        </TableCell>
        <TableCell scope="row" style={{ border: '1px solid black', height: 210, overflow: 'scroll' }}>
          <Table>
            <TableBody>
              {Object.keys(referredUsers || {}).map((userId) => (
                <TableRow key={userId}>
                  <TableCell scope="row">
                    <a href={'/users/' + userId}>{referredUsers[userId].alias}</a>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableCell>
      </TableRow>
    </TableBody>
  </Table>
);

 
export default withFirebase(UserPage);